import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { connect, useSelector, useDispatch } from "react-redux";
import Layout from "../../components/layout/Layout";
import { Link } from "react-router-dom";
import search from "../../utils/search";
import Pagination from "./../../components/Pagination";
// import vehicleImg from "../../assets/images/dumiVehicle.png";
import { CSVLink } from "react-csv";
import dateFormat from "dateformat";
import {
  ManageRentVehicleList,
  deleteMultiRentVehicle,
} from "../../redux/action/rentVehicle";
import loader from "../../components/loader/loader";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
const RentVehicleList = ({ pageLoading, renVehicleData, not_found }) => {
  const dispatch = useDispatch();

  const rentVehicles = renVehicleData?.data
    ? renVehicleData?.data?.rentVehicle
    : "";

  // // // // // // // // // // // // // // // // // // //
  const [filterDate, setFilterData] = useState({
    startDate: "",
    endDate: "",
  });
  const [listData, setListData] = useState([]);
  const [filterStatus, setFilterStatus] = useState(false);

  const startDate = filterDate?.startDate;
  const endDate = filterDate?.endDate;

  const handleOnchangeFilter = (e) => {
    const { name, value } = e.target;
    setFilterData({
      ...filterDate,
      [name]: value,
    });
  };

  const handleResetFilter = () => {
    setFilterData({ startDate: "", endDate: "" });
    setFilterStatus(false);
  };

  useEffect(() => {
    if (!rentVehicles) return;
    if (!startDate && !endDate) {
      setFilterStatus(false);
      setListData(rentVehicles);
      return;
    }
    const filteredDataList = rentVehicles.filter((obj) => {
      const objDate = dateFormat(obj.createdAt, "yyyy-mm-dd");
      return (!startDate || objDate >= startDate) && (!endDate || objDate <= endDate);
    });
    setFilterStatus(true);
    setListData(filteredDataList);
  }, [rentVehicles, startDate, endDate]);

  const [productDataList, setProductDataList] = useState([]);
  const onChangePage = (pageOfItems) => {
    setProductDataList(pageOfItems);
  };

  useEffect(() => {
    dispatch(ManageRentVehicleList());
  }, [dispatch]);

  const headers = [
    { label: "_id", key: "id" },
    { label: "SR No.", key: "request" },
    { label: "Name of customer", key: "name_of_customer" },
    { label: "Phone number", key: "phone_number" },
    { label: "Vehicle rented", key: "vehicle_rented" },
    { label: "Date rented from", key: "date_rented_from" },
    { label: "Date rented upto", key: "date_rented_upto" },
    { label: "Total Price($)", key: "totalPrice" },
    { label: "Status", key: "status" },
    { label: "Created_At", key: "created" },
    { label: "Updated_At", key: "updated" },
  ];
  // const data = productDataList
  //   ? productDataList?.map((item) => {
  //       return {
  //         id: item?._id ? item?._id : "N/A",
  //         name_of_customer:
  //           item.customer_id?.firstName && item.customer_id?.lastName
  //             ? item.customer_id?.firstName + " " + item.customer_id?.lastName
  //             : "N/A",
  //         phone_number: item?.customer_id?.phone
  //           ? item?.customer_id?.phone
  //           : "N/A",
  //         vehicle_rented: item?.vehicle_id?.name
  //           ? item?.vehicle_id?.name
  //           : "N/A",
  //         date_rented_from: item?.fromDate ? item?.fromDate : "N/A",
  //         date_rented_upto: item?.toDate ? item?.toDate : "N/A",
  //         totalPrice: item?.totalPrice ? item?.totalPrice : "N/A",
  //         status: item?.isBooked ? item?.isBooked : "N/A",
  //         created: item?.createdAt ? item?.createdAt : "N/A",
  //         updated: item?.updatedAt ? item?.updatedAt : "N/A",
  //       };
  //     })
  //   : "";

  const [loading, setLoading] = React.useState(true);

  setTimeout(() => {
    setLoading(false);
  }, 30000);

  const getBadge = (isBooked) => {
    switch (isBooked) {
      case "booked":
        return "success";
      case "book":
        return "secondary";
      case "submited":
        return "badge-info";
      default:
        return "primary";
    }
  };

  // *********** All Select Delete ***********
  const [btnStatus, setBtnStatus] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(productDataList);
  }, [productDataList]);

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(list.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };
  const handleAllDelete = () => {
    dispatch(deleteMultiRentVehicle(isCheck));
    setTimeout(() => {
      dispatch(ManageRentVehicleList());
      setIsCheckAll(false);
      setIsCheck([]);
    }, 1000);
  };
  // Download csv files - export the selected rows, or the whole visible list if nothing is checked
  const seledCsvList =
    isCheck?.length > 0
      ? productDataList?.filter((item) => isCheck?.includes(item?.id))
      : productDataList;

  const data = seledCsvList
    ? seledCsvList?.map((item) => {
      return {
        id: item?._id ? item?._id : "N/A",
        invoice_no:
          item.invoice_no && item.invoice_no
            ? item.invoice_no + " " + item.invoice_no
            : "N/A",
        name_of_customer:
          item.customer_id?.firstName && item.customer_id?.lastName
            ? item.customer_id?.firstName + " " + item.customer_id?.lastName
            : "N/A",
        phone_number: item?.customer_id?.phone
          ? item?.customer_id?.phone
          : "N/A",
        vehicle_rented: item?.vehicle_id?.name
          ? item?.vehicle_id?.name
          : "N/A",
        date_rented_from: item?.fromDate ? item?.fromDate : "N/A",
        date_rented_upto: item?.toDate ? item?.toDate : "N/A",
        totalPrice: item?.totalPrice ? item?.totalPrice : "N/A",
        status: item?.isBooked ? item?.isBooked : "N/A",
        created: item?.createdAt ? item?.createdAt : "N/A",
        updated: item?.updatedAt ? item?.updatedAt : "N/A",
      };
    })
    : "";

  // pdf code start
  const downloadPDF = () => {
    const capture = document.querySelector(".table");
    html2canvas(capture).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      console.log("Image Data:", imgData); // Debugging: Log the image data
      const doc = new jsPDF("p", "mm", "a4");
      const imgWidth = 200; // Adjust this based on your needs
      const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio
      doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      doc.save("roadside-response.pdf");
    });
  };
  // pdf code end

  return (
    <React.Fragment>
      <ToastContainer autoClose={1000} />
      <Layout title="Rental Orders" page="rental-vehicle-orders">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row pt-4 pb-4">
              <div className="col-sm-6 d-flex align-items-center justify-conten-start">
                <div
                  className="dataTables_length"
                  id="kt_datatable_example_5_length"
                >
                  {isCheck && isCheck?.length > 0 ? (
                    <button
                      onClick={() => {
                        handleAllDelete();
                      }}
                      className="delete-selected me-5"
                    >
                      Delete Selected
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <div className="filter-table-data ml-5 d-flex align-items-center">
                  <div className="">
                    <input
                      className="form-control"
                      name="startDate"
                      type="date"
                      value={startDate}
                      onChange={(e) => {
                        handleOnchangeFilter(e);
                      }}
                    />
                  </div>
                  <span className="mx-4 fw-bolder">To</span>
                  <div>
                    <input
                      className="form-control"
                      name="endDate"
                      type="date"
                      min={startDate || ""}
                      value={endDate}
                      onChange={(e) => {
                        handleOnchangeFilter(e);
                      }}
                    />
                  </div>
                  {(startDate || endDate) ? (
                    <button
                      type="button"
                      className="btn btn-light-danger ms-2"
                      onClick={handleResetFilter}
                    >
                      Reset
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-sm-6 d-flex align-items-center justify-content-end">
                <div
                  id="kt_datatable_example_5_filter"
                  className="dataTables_filter"
                >
                  <label>
                    Search:
                    <input
                      type="search"
                      onChange={() => {
                        search();
                      }}
                      id="myInput"
                      className="form-control form-control-sm form-control-solid"
                      placeholder=""
                      aria-controls="kt_datatable_example_5"
                    />
                  </label>
                </div>

                <div className="ms-3">
                  <a
                    className="btn pgf btn-secondary dropdown-toggle"
                    href="#"
                    // role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    // className="csvlink"
                    style={{ background: "none" }}
                  >
                    Download File
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item">
                        <CSVLink
                          style={{ color: "#000" }}
                          data={data}
                          headers={headers}
                        >
                          Download as CSV
                        </CSVLink>
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" onClick={downloadPDF}>
                        Download as PDF
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="table-responsive table-wrapper">
              <table
                id="kt_datatable_example_5"
                className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer status"
                aria-describedby="kt_datatable_example_5_info"
              >
                <thead>
                  <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                    <th style={{ padding: "16px 0px 16px 24px" }}>
                      <input
                        type="checkbox"
                        name="selectAll"
                        id="selectAll"
                        onClick={() => {
                          handleSelectAll();
                          setBtnStatus(true);
                        }}
                        checked={isCheckAll}
                        className="form-check-input custum-check"
                      />
                    </th>
                    <th style={{ width: "53.906px" }}>SR No.</th>
                    <th>Name of customer</th>
                    <th>Phone number</th>
                    <th>Vehicle rented</th>
                    <th>Date rented from</th>
                    <th>Date rented up to</th>
                    <th>Total Price($)</th>
                    <th>Date & Time</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!pageLoading && rentVehicles && rentVehicles?.length ? (
                    productDataList &&
                    productDataList?.map((item, index) => {
                      return (
                        <tr key={index} className="pro-list-info">
                          {/* <td>
                            <img
                              className="service-img"
                              src={
                                item?.vehicle_id?.image !== "undefined"
                                  ? item?.vehicle_id?.image
                                  : vehicleImg
                              }
                              alt="vehicle image"
                            />
                          </td> */}
                          <td style={{ width: "20px" }} className="check-list">
                            <input
                              type="checkbox"
                              name={item?.firstName}
                              id={item?.id}
                              onClick={(e) => {
                                handleClick(e);
                              }}
                              checked={isCheck?.includes(item?.id)}
                              className="form-check-input custum-check"
                            />
                          </td>
                          <td>{item?.invoice_no ? item?.invoice_no : "N/A"}</td>
                          <td>
                            {item?.customer_id?.firstName
                              ? item?.customer_id?.firstName +
                              " " +
                              item?.customer_id?.lastName
                              : "N/A"}
                          </td>
                          <td>
                            {item?.customer_id?.phone
                              ? item?.customer_id?.phone
                              : "N/A"}
                          </td>
                          <td>
                            {item?.vehicle_id?.name
                              ? `${item?.vehicle_id?.name}`
                              : "N/A"}
                          </td>
                          <td>
                            {item?.fromDate ? `${item?.fromDate}` : "N/A"}
                          </td>
                          <td>{item?.toDate ? `${item?.toDate}` : "N/A"}</td>
                          <td>
                            {item?.totalPrice
                              ? `$${item?.totalPrice}`
                              : item?.perWeekTotalPrice
                                ? `$${item?.perWeekTotalPrice}`
                                : "N/A"}
                          </td>
                          <td>
                            {item?.createdAt
                              ? dateFormat(
                                item?.createdAt,
                                "mm/dd/yyyy HH:mm:ss"
                              )
                              : "N/A"}
                          </td>
                          <td>
                            <span className={`btn ${getBadge(item?.isBooked)}`}>
                              {item?.isBooked == "book"
                                ? "Book"
                                : item?.isBooked == "booked"
                                  ? "Booked"
                                  : item?.isBooked == "submited"
                                    ? "Submited"
                                    : ""}
                            </span>
                          </td>
                          <td>
                         
                            <Link
                              to={`/rental-orders-edit/${item?.id}`}
                              className="btn btn-info action-hover"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-pencil-square"
                                viewBox="0 0 16 16"
                              >
                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                <path
                                  fillRule="evenodd"
                                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                />
                              </svg>
                            </Link>
                          </td>
                          <td>
                            <Link
                              to={`/rental-orders-details/${item?.id}`}
                              className="btn btn-bg-primary action-hover"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                              </svg>
                            </Link>
                          </td>
                        </tr>
                      );
                    })
                  ) : !not_found ? (
                    <div className="spinner-outer p-5">{loader()}</div>
                  ) : (
                    <div className="spinner-outer p-5">
                      <p>Data not found</p>
                    </div>
                  )}
                  {!filterStatus == false && !listData?.length && (
                    <div className="spinner-outer p-5">
                      <p>Data not found</p>
                    </div>
                  )}
                </tbody>
              </table>
            </div>
            {listData && listData ? (
              <Pagination
                pageSize={10}
                items={listData}
                onChangePage={onChangePage}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoading: state?.rentVehicle?.loading,
  renVehicleData: state?.rentVehicle?.list,
  not_found: state?.rentVehicle?.not_found,
});

export default connect(mapStateToProps, { ManageRentVehicleList })(
  RentVehicleList
);
